import makeService from './api';

export default makeService('security_parameters');
